import Component from '../../shared/component';

// We can't use Stickyfill for this component since it needs a width adjustment
// when "sticked"
export default class StickyNavbar extends Component {
  constructor(stickyElement, scrollerElement) {
    super(...arguments);
    this.$navbar = $(stickyElement);
    this.$bodyElement = $('body');
    this.$scroller = $(scrollerElement);

    this.bindEvents();
  }

  bindEvents() {
    this.bindStickyScroll();
  }

  bindStickyScroll() {
    this.$scroller.scroll(() => {
      if (this.$scroller.scrollTop() > 1) {
        this.$bodyElement.addClass('scrolled');
        this.$navbar.addClass('sticky-navbar--sticked');
      }
      if (this.$scroller.scrollTop() < 1) {
        this.$bodyElement.removeClass('scrolled');
        this.$navbar.removeClass('sticky-navbar--sticked');
      }
    });
  }

  unbindEvents() {
    this.$scroller.off('scroll');
  }
}
